// Add smooth scroll to links
export default function useSmoothScroll () {
    const element = document.querySelector( "html" )

    element.classList.add( "smooth-scroll" )
}
